/**
 * @generated SignedSource<<b1eceb30a8cbb74ebe6b4328e45256b3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UpdateStateFilter = "ACTIVE" | "AT_RISK" | "CANCELLED" | "DONE" | "NO_UPDATE" | "OFF_TRACK" | "ON_TRACK" | "PAUSED" | "PENDING";
export type ReadingModeFullScreenQuery$variables = {
  createdAfter?: string | null;
  createdBefore?: string | null;
  isGoalUpdates: boolean;
  isProjectUpdates: boolean;
  isTagUpdates: boolean;
  isTeamUpdates: boolean;
  stateFilter?: UpdateStateFilter | null;
  tagUuid?: string | null;
  teamId: string;
  workspaceUUID: string;
};
export type ReadingModeFullScreenQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"hooks_GoalPagination" | "hooks_ProjectPagination" | "hooks_TagPagination" | "hooks_TeamPagination">;
};
export type ReadingModeFullScreenQuery = {
  response: ReadingModeFullScreenQuery$data;
  variables: ReadingModeFullScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "createdAfter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "createdBefore"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isGoalUpdates"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isProjectUpdates"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTagUpdates"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTeamUpdates"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stateFilter"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagUuid"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceUUID"
},
v10 = {
  "kind": "Variable",
  "name": "createdAfter",
  "variableName": "createdAfter"
},
v11 = {
  "kind": "Variable",
  "name": "createdBefore",
  "variableName": "createdBefore"
},
v12 = {
  "kind": "Literal",
  "name": "first",
  "value": 15
},
v13 = {
  "kind": "Variable",
  "name": "stateFilter",
  "variableName": "stateFilter"
},
v14 = {
  "kind": "Variable",
  "name": "workspaceUUID",
  "variableName": "workspaceUUID"
},
v15 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/)
],
v16 = [
  (v10/*: any*/),
  (v12/*: any*/),
  {
    "kind": "Variable",
    "name": "teamId",
    "variableName": "teamId"
  },
  (v14/*: any*/)
],
v17 = [
  (v10/*: any*/),
  (v12/*: any*/),
  {
    "kind": "Variable",
    "name": "tagUuid",
    "variableName": "tagUuid"
  }
],
v18 = [
  (v10/*: any*/),
  (v11/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/)
],
v19 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v20 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isUpdate"
},
v21 = {
  "kind": "ScalarField",
  "name": "id"
},
v22 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v23 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v24 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v25 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v26 = {
  "kind": "ScalarField",
  "name": "picture"
},
v27 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v28 = {
  "kind": "ScalarField",
  "name": "name"
},
v29 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v30 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": [
    (v25/*: any*/),
    (v21/*: any*/),
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        (v26/*: any*/),
        (v27/*: any*/),
        (v28/*: any*/),
        (v29/*: any*/)
      ]
    }
  ]
},
v31 = {
  "kind": "ScalarField",
  "name": "ari"
},
v32 = {
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "workspace",
  "plural": false,
  "selections": [
    (v22/*: any*/),
    (v21/*: any*/)
  ]
},
v33 = {
  "kind": "ScalarField",
  "name": "watching"
},
v34 = {
  "kind": "ScalarField",
  "name": "key"
},
v35 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v36 = [
  (v21/*: any*/),
  (v35/*: any*/)
],
v37 = {
  "kind": "ScalarField",
  "name": "latestUpdateDate"
},
v38 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  }
],
v39 = {
  "kind": "ScalarField",
  "name": "description"
},
v40 = {
  "args": (v38/*: any*/),
  "concreteType": "TagConnection",
  "kind": "LinkedField",
  "name": "tagsWatchedByUser",
  "plural": false,
  "selections": [
    {
      "concreteType": "TagEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Tag",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v21/*: any*/),
            (v28/*: any*/),
            (v22/*: any*/),
            (v39/*: any*/),
            {
              "kind": "ScalarField",
              "name": "projectUsageCount"
            },
            {
              "kind": "ScalarField",
              "name": "goalUsageCount"
            },
            {
              "kind": "ScalarField",
              "name": "helpPointerUsageCount"
            },
            {
              "kind": "ScalarField",
              "name": "watcherCount"
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "tagsWatchedByUser(first:3)"
},
v41 = {
  "args": (v38/*: any*/),
  "concreteType": "TeamConnection",
  "kind": "LinkedField",
  "name": "teamsWatchedByUser",
  "plural": false,
  "selections": [
    {
      "concreteType": "TeamEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v21/*: any*/),
            (v28/*: any*/),
            {
              "kind": "ScalarField",
              "name": "teamId"
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "teamsWatchedByUser(first:3)"
},
v42 = {
  "kind": "ScalarField",
  "name": "type"
},
v43 = {
  "kind": "ScalarField",
  "name": "summary"
},
v44 = [
  (v34/*: any*/),
  (v31/*: any*/),
  (v21/*: any*/)
],
v45 = [
  {
    "concreteType": "UserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      (v28/*: any*/),
      (v26/*: any*/),
      (v27/*: any*/)
    ]
  },
  (v25/*: any*/),
  (v21/*: any*/)
],
v46 = {
  "kind": "ScalarField",
  "name": "count"
},
v47 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v48 = {
  "concreteType": "CommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "CommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "Comment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v21/*: any*/),
            (v47/*: any*/),
            (v31/*: any*/),
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v35/*: any*/),
            {
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v25/*: any*/),
                {
                  "concreteType": "UserPII",
                  "kind": "LinkedField",
                  "name": "pii",
                  "plural": false,
                  "selections": [
                    (v26/*: any*/),
                    (v28/*: any*/),
                    (v29/*: any*/),
                    (v27/*: any*/)
                  ]
                },
                (v21/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ]
},
v49 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": [
    (v25/*: any*/),
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        (v28/*: any*/)
      ]
    },
    (v21/*: any*/)
  ]
},
v50 = {
  "kind": "ScalarField",
  "name": "label"
},
v51 = [
  {
    "kind": "ScalarField",
    "name": "messageId"
  }
],
v52 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": (v51/*: any*/)
},
v53 = [
  {
    "kind": "Literal",
    "name": "longFormat",
    "value": true
  }
],
v54 = [
  {
    "kind": "ScalarField",
    "name": "confidence"
  },
  (v50/*: any*/),
  (v52/*: any*/),
  {
    "alias": "tooltip",
    "args": (v53/*: any*/),
    "kind": "ScalarField",
    "name": "label",
    "storageKey": "label(longFormat:true)"
  },
  {
    "alias": "localizedTooltip",
    "args": (v53/*: any*/),
    "concreteType": "LocalizationField",
    "kind": "LinkedField",
    "name": "localizedLabel",
    "plural": false,
    "selections": (v51/*: any*/),
    "storageKey": "localizedLabel(longFormat:true)"
  },
  {
    "kind": "ScalarField",
    "name": "overdue"
  }
],
v55 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "newDueDate",
  "plural": false,
  "selections": (v54/*: any*/)
},
v56 = {
  "kind": "ScalarField",
  "name": "value"
},
v57 = {
  "concreteType": "CompletionProjectState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": [
    (v56/*: any*/),
    (v50/*: any*/),
    (v52/*: any*/)
  ]
},
v58 = {
  "kind": "ScalarField",
  "name": "archived"
},
v59 = {
  "kind": "ScalarField",
  "name": "title"
},
v60 = {
  "concreteType": "TargetDate",
  "kind": "LinkedField",
  "name": "oldDueDate",
  "plural": false,
  "selections": (v54/*: any*/)
},
v61 = {
  "kind": "ScalarField",
  "name": "url"
},
v62 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/),
    (v22/*: any*/),
    (v23/*: any*/),
    (v24/*: any*/),
    (v30/*: any*/),
    (v31/*: any*/),
    {
      "concreteType": "Project",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v31/*: any*/),
        (v22/*: any*/),
        (v32/*: any*/),
        (v21/*: any*/),
        (v33/*: any*/),
        {
          "kind": "ScalarField",
          "name": "private"
        },
        {
          "concreteType": "IconURIs",
          "kind": "LinkedField",
          "name": "iconUrl",
          "plural": false,
          "selections": [
            {
              "concreteType": "ThemeURIs",
              "kind": "LinkedField",
              "name": "square",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "light"
                },
                {
                  "kind": "ScalarField",
                  "name": "dark"
                },
                {
                  "kind": "ScalarField",
                  "name": "transparent"
                }
              ]
            }
          ]
        },
        (v34/*: any*/),
        (v28/*: any*/),
        {
          "concreteType": "ProjectUpdate",
          "kind": "LinkedField",
          "name": "latestUserUpdate",
          "plural": false,
          "selections": (v36/*: any*/)
        },
        (v37/*: any*/),
        (v40/*: any*/),
        (v41/*: any*/)
      ]
    },
    (v35/*: any*/),
    {
      "kind": "ScalarField",
      "name": "newTargetDate"
    },
    {
      "concreteType": "ProjectChangelogItem",
      "kind": "LinkedField",
      "name": "changelog",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "newValue"
        },
        {
          "kind": "ScalarField",
          "name": "oldValue"
        },
        (v21/*: any*/)
      ]
    },
    {
      "concreteType": "LearningConnection",
      "kind": "LinkedField",
      "name": "learnings",
      "plural": false,
      "selections": [
        {
          "concreteType": "LearningEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "Learning",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v42/*: any*/),
                (v22/*: any*/),
                (v21/*: any*/),
                (v43/*: any*/),
                (v39/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v31/*: any*/),
                    {
                      "concreteType": "Project",
                      "kind": "LinkedField",
                      "name": "project",
                      "plural": false,
                      "selections": (v44/*: any*/)
                    },
                    {
                      "concreteType": "Goal",
                      "kind": "LinkedField",
                      "name": "goal",
                      "plural": false,
                      "selections": (v44/*: any*/)
                    },
                    {
                      "concreteType": "User",
                      "kind": "LinkedField",
                      "name": "creator",
                      "plural": false,
                      "selections": (v45/*: any*/)
                    },
                    (v35/*: any*/),
                    {
                      "concreteType": "User",
                      "kind": "LinkedField",
                      "name": "lastEditedBy",
                      "plural": false,
                      "selections": (v45/*: any*/)
                    },
                    {
                      "kind": "ScalarField",
                      "name": "lastEditedDate"
                    }
                  ],
                  "type": "Highlight",
                  "abstractKey": "__isHighlight"
                }
              ]
            }
          ]
        },
        (v46/*: any*/)
      ]
    },
    (v48/*: any*/),
    (v47/*: any*/),
    (v49/*: any*/),
    (v55/*: any*/),
    {
      "alias": "newProjectState",
      "concreteType": "ProjectState",
      "kind": "LinkedField",
      "name": "newState",
      "plural": false,
      "selections": [
        (v56/*: any*/),
        (v50/*: any*/),
        (v52/*: any*/),
        (v57/*: any*/)
      ]
    },
    (v43/*: any*/),
    {
      "concreteType": "UpdateNote",
      "kind": "LinkedField",
      "name": "notes",
      "plural": true,
      "selections": [
        (v22/*: any*/),
        (v58/*: any*/),
        (v59/*: any*/),
        (v43/*: any*/),
        (v21/*: any*/),
        (v19/*: any*/)
      ]
    },
    (v60/*: any*/),
    {
      "alias": "oldProjectState",
      "concreteType": "ProjectState",
      "kind": "LinkedField",
      "name": "oldState",
      "plural": false,
      "selections": [
        (v50/*: any*/),
        (v52/*: any*/),
        (v56/*: any*/),
        (v57/*: any*/)
      ]
    },
    {
      "concreteType": "MilestoneConnection",
      "kind": "LinkedField",
      "name": "milestones",
      "plural": false,
      "selections": [
        {
          "concreteType": "MilestoneEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "Milestone",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v22/*: any*/),
                (v21/*: any*/),
                (v59/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "targetDate"
                },
                {
                  "kind": "ScalarField",
                  "name": "targetDateType"
                },
                {
                  "kind": "ScalarField",
                  "name": "status"
                }
              ]
            }
          ]
        },
        (v46/*: any*/)
      ]
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v61/*: any*/),
            {
              "concreteType": "Goal",
              "kind": "LinkedField",
              "name": "goal",
              "plural": false,
              "selections": [
                (v34/*: any*/),
                (v21/*: any*/)
              ]
            }
          ],
          "type": "GoalUpdate"
        }
      ],
      "type": "Update",
      "abstractKey": "__isUpdate"
    }
  ],
  "type": "ProjectUpdate"
},
v63 = [
  (v21/*: any*/)
],
v64 = [
  (v56/*: any*/),
  (v21/*: any*/)
],
v65 = {
  "kind": "ScalarField",
  "name": "subType"
},
v66 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v67 = {
  "args": [
    {
      "kind": "Literal",
      "name": "includeScore",
      "value": false
    }
  ],
  "kind": "ScalarField",
  "name": "label",
  "storageKey": "label(includeScore:false)"
},
v68 = {
  "kind": "ScalarField",
  "name": "score"
},
v69 = {
  "concreteType": "CompletionGoalState",
  "kind": "LinkedField",
  "name": "atCompletionState",
  "plural": false,
  "selections": [
    (v67/*: any*/),
    (v52/*: any*/),
    (v56/*: any*/),
    (v68/*: any*/)
  ]
},
v70 = {
  "kind": "InlineFragment",
  "selections": [
    (v21/*: any*/),
    (v22/*: any*/),
    (v30/*: any*/),
    (v23/*: any*/),
    (v24/*: any*/),
    (v31/*: any*/),
    {
      "concreteType": "Goal",
      "kind": "LinkedField",
      "name": "goal",
      "plural": false,
      "selections": [
        (v31/*: any*/),
        (v22/*: any*/),
        (v32/*: any*/),
        (v21/*: any*/),
        (v33/*: any*/),
        {
          "concreteType": "TownsquareGoalCapabilities",
          "kind": "LinkedField",
          "name": "capabilities",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "canWatchGoal"
            },
            {
              "kind": "ScalarField",
              "name": "canCommentOnUpdates"
            }
          ]
        },
        {
          "concreteType": "Goal",
          "kind": "LinkedField",
          "name": "parentGoal",
          "plural": false,
          "selections": (v63/*: any*/)
        },
        (v34/*: any*/),
        (v28/*: any*/),
        {
          "concreteType": "GoalIcon",
          "kind": "LinkedField",
          "name": "icon",
          "plural": false,
          "selections": [
            (v34/*: any*/),
            {
              "kind": "ScalarField",
              "name": "appearance"
            }
          ]
        },
        {
          "concreteType": "GoalUpdate",
          "kind": "LinkedField",
          "name": "latestUserUpdate",
          "plural": false,
          "selections": (v36/*: any*/)
        },
        (v37/*: any*/),
        {
          "concreteType": "GoalConnection",
          "kind": "LinkedField",
          "name": "subGoals",
          "plural": false,
          "selections": [
            (v46/*: any*/)
          ]
        },
        {
          "concreteType": "MetricTargetConnection",
          "kind": "LinkedField",
          "name": "metricTargets",
          "plural": false,
          "selections": [
            {
              "concreteType": "MetricTargetEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "concreteType": "MetricTarget",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "startValue"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "targetValue"
                    },
                    (v21/*: any*/),
                    {
                      "concreteType": "MetricValue",
                      "kind": "LinkedField",
                      "name": "snapshotValue",
                      "plural": false,
                      "selections": (v64/*: any*/)
                    },
                    {
                      "concreteType": "Metric",
                      "kind": "LinkedField",
                      "name": "metric",
                      "plural": false,
                      "selections": [
                        (v21/*: any*/),
                        (v28/*: any*/),
                        (v42/*: any*/),
                        (v65/*: any*/),
                        (v58/*: any*/),
                        {
                          "kind": "ScalarField",
                          "name": "source"
                        },
                        {
                          "concreteType": "MetricValue",
                          "kind": "LinkedField",
                          "name": "latestValue",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "ScalarField",
                              "name": "time"
                            },
                            (v21/*: any*/)
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "concreteType": "GoalProgress",
          "kind": "LinkedField",
          "name": "progress",
          "plural": false,
          "selections": [
            (v66/*: any*/),
            (v42/*: any*/)
          ]
        },
        (v40/*: any*/),
        (v41/*: any*/)
      ]
    },
    (v35/*: any*/),
    {
      "concreteType": "GoalMetricUpdateConnection",
      "kind": "LinkedField",
      "name": "metricUpdate",
      "plural": false,
      "selections": [
        {
          "concreteType": "GoalMetricUpdateEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "GoalMetricUpdate",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "newStartValue"
                },
                {
                  "kind": "ScalarField",
                  "name": "newTargetValue"
                },
                {
                  "concreteType": "MetricValue",
                  "kind": "LinkedField",
                  "name": "newValue",
                  "plural": false,
                  "selections": (v64/*: any*/)
                },
                {
                  "concreteType": "Metric",
                  "kind": "LinkedField",
                  "name": "metric",
                  "plural": false,
                  "selections": [
                    (v21/*: any*/),
                    (v28/*: any*/),
                    (v42/*: any*/),
                    (v65/*: any*/),
                    (v58/*: any*/)
                  ]
                },
                {
                  "concreteType": "MetricValue",
                  "kind": "LinkedField",
                  "name": "oldValue",
                  "plural": false,
                  "selections": (v64/*: any*/)
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "concreteType": "GoalProgress",
      "kind": "LinkedField",
      "name": "newProgress",
      "plural": false,
      "selections": [
        (v42/*: any*/),
        (v66/*: any*/)
      ]
    },
    (v48/*: any*/),
    (v49/*: any*/),
    (v47/*: any*/),
    {
      "alias": "newGoalState",
      "concreteType": "GoalState",
      "kind": "LinkedField",
      "name": "newState",
      "plural": false,
      "selections": [
        (v56/*: any*/),
        (v67/*: any*/),
        (v52/*: any*/),
        (v68/*: any*/),
        (v69/*: any*/)
      ]
    },
    (v55/*: any*/),
    (v43/*: any*/),
    {
      "concreteType": "UpdateNote",
      "kind": "LinkedField",
      "name": "notes",
      "plural": true,
      "selections": [
        (v58/*: any*/),
        (v22/*: any*/),
        (v59/*: any*/),
        (v43/*: any*/),
        (v21/*: any*/)
      ]
    },
    (v60/*: any*/),
    {
      "alias": "oldGoalState",
      "concreteType": "GoalState",
      "kind": "LinkedField",
      "name": "oldState",
      "plural": false,
      "selections": [
        (v67/*: any*/),
        (v52/*: any*/),
        (v68/*: any*/),
        (v56/*: any*/),
        (v69/*: any*/)
      ]
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v61/*: any*/)
          ],
          "type": "GoalUpdate"
        }
      ],
      "type": "Update",
      "abstractKey": "__isUpdate"
    }
  ],
  "type": "GoalUpdate"
},
v71 = {
  "kind": "InlineFragment",
  "selections": (v63/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v72 = {
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    (v20/*: any*/),
    (v62/*: any*/),
    (v70/*: any*/),
    (v71/*: any*/)
  ]
},
v73 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v74 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v75 = [
  {
    "concreteType": "UpdateEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      (v72/*: any*/),
      (v73/*: any*/)
    ]
  },
  (v74/*: any*/)
],
v76 = [
  "createdBefore",
  "createdAfter",
  "workspaceUUID",
  "stateFilter"
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ReadingModeFullScreenQuery",
    "selections": [
      {
        "condition": "isProjectUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v15/*: any*/),
            "kind": "FragmentSpread",
            "name": "hooks_ProjectPagination"
          }
        ]
      },
      {
        "condition": "isGoalUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v15/*: any*/),
            "kind": "FragmentSpread",
            "name": "hooks_GoalPagination"
          }
        ]
      },
      {
        "condition": "isTeamUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v16/*: any*/),
            "kind": "FragmentSpread",
            "name": "hooks_TeamPagination"
          }
        ]
      },
      {
        "condition": "isTagUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v17/*: any*/),
            "kind": "FragmentSpread",
            "name": "hooks_TagPagination"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v9/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReadingModeFullScreenQuery",
    "selections": [
      {
        "condition": "isProjectUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v18/*: any*/),
            "kind": "ScalarField",
            "name": "allWatchedProjectUpdatesCount"
          },
          {
            "args": (v15/*: any*/),
            "concreteType": "UpdateConnection",
            "kind": "LinkedField",
            "name": "allWatchedProjectUpdates",
            "plural": false,
            "selections": (v75/*: any*/)
          },
          {
            "args": (v15/*: any*/),
            "filters": (v76/*: any*/),
            "handle": "connection",
            "key": "ReadingModeInternals_allWatchedProjectUpdates",
            "kind": "LinkedHandle",
            "name": "allWatchedProjectUpdates"
          }
        ]
      },
      {
        "condition": "isGoalUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v18/*: any*/),
            "kind": "ScalarField",
            "name": "allWatchedGoalUpdatesCount"
          },
          {
            "args": (v15/*: any*/),
            "concreteType": "UpdateConnection",
            "kind": "LinkedField",
            "name": "allWatchedGoalUpdates",
            "plural": false,
            "selections": (v75/*: any*/)
          },
          {
            "args": (v15/*: any*/),
            "filters": (v76/*: any*/),
            "handle": "connection",
            "key": "ReadingModeInternals_allWatchedGoalUpdates",
            "kind": "LinkedHandle",
            "name": "allWatchedGoalUpdates"
          }
        ]
      },
      {
        "condition": "isTeamUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v16/*: any*/),
            "concreteType": "UpdateConnection",
            "kind": "LinkedField",
            "name": "updatesWithTeam",
            "plural": false,
            "selections": [
              {
                "concreteType": "UpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v72/*: any*/),
                  (v19/*: any*/),
                  (v73/*: any*/)
                ]
              },
              (v74/*: any*/)
            ]
          },
          {
            "args": (v16/*: any*/),
            "filters": [
              "teamId",
              "workspaceUUID",
              "createdAfter"
            ],
            "handle": "connection",
            "key": "TeamUpdatesFeed_updatesWithTeam",
            "kind": "LinkedHandle",
            "name": "updatesWithTeam"
          }
        ]
      },
      {
        "condition": "isTagUpdates",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v17/*: any*/),
            "concreteType": "UpdateConnection",
            "kind": "LinkedField",
            "name": "updatesWithTag",
            "plural": false,
            "selections": [
              {
                "concreteType": "UpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v19/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/),
                      (v19/*: any*/),
                      (v62/*: any*/),
                      (v70/*: any*/),
                      (v71/*: any*/)
                    ]
                  },
                  (v73/*: any*/)
                ]
              },
              (v74/*: any*/)
            ]
          },
          {
            "args": (v17/*: any*/),
            "filters": [
              "tagUuid",
              "createdAfter"
            ],
            "handle": "connection",
            "key": "TagUpdatesFeed_updatesWithTag",
            "kind": "LinkedHandle",
            "name": "updatesWithTag"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "0f5bad143d2b3f93e549ad4bc7e4377b",
    "id": null,
    "metadata": {},
    "name": "ReadingModeFullScreenQuery",
    "operationKind": "query",
    "text": "query ReadingModeFullScreenQuery(\n  $isProjectUpdates: Boolean!\n  $isGoalUpdates: Boolean!\n  $isTeamUpdates: Boolean!\n  $isTagUpdates: Boolean!\n  $workspaceUUID: UUID!\n  $createdBefore: DateTime\n  $createdAfter: DateTime\n  $stateFilter: UpdateStateFilter\n  $teamId: String!\n  $tagUuid: UUID\n) {\n  ...hooks_ProjectPagination_2vmIz0 @include(if: $isProjectUpdates)\n  ...hooks_GoalPagination_2vmIz0 @include(if: $isGoalUpdates)\n  ...hooks_TeamPagination_19TOuK @include(if: $isTeamUpdates)\n  ...hooks_TagPagination_FV1D3 @include(if: $isTagUpdates)\n}\n\nfragment Comment on Comment {\n  id\n  ari\n  commentText\n  creationDate\n  editDate\n  creator {\n    aaid\n    ...UserAvatar\n    id\n  }\n}\n\nfragment Comments on CommentConnection {\n  edges {\n    node {\n      id\n      editDate\n      ...Comment\n    }\n  }\n}\n\nfragment GoalDateChanged on GoalUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalFollowButton on Goal {\n  id\n  uuid\n  watching\n  capabilities {\n    canWatchGoal\n  }\n}\n\nfragment GoalMissedUpdateLabel on GoalUpdate {\n  creationDate\n  missedUpdate\n  updateType\n  goal {\n    id\n    key\n    latestUserUpdate {\n      id\n      creationDate\n    }\n    latestUpdateDate\n  }\n}\n\nfragment GoalProgressChanged on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        metric {\n          type\n          subType\n          archived\n          id\n        }\n        newStartValue\n        newValue {\n          value\n          id\n        }\n        oldValue {\n          value\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment GoalState on GoalState {\n  label(includeScore: false)\n  localizedLabel {\n    messageId\n  }\n  score\n  value\n  atCompletionState {\n    label(includeScore: false)\n    localizedLabel {\n      messageId\n    }\n    value\n    score\n  }\n}\n\nfragment GoalStatusChanged on GoalUpdate {\n  newGoalState: newState {\n    ...GoalState\n  }\n  oldGoalState: oldState {\n    ...GoalState\n  }\n}\n\nfragment GoalUpdateCard on GoalUpdate {\n  id\n  uuid\n  creator {\n    aaid\n    id\n  }\n  missedUpdate\n  updateType\n  ...MissedGoalUpdateCard\n  ...GoalUpdateCardInternal\n  goal {\n    uuid\n    id\n  }\n}\n\nfragment GoalUpdateCardByline on Goal {\n  watching\n  tagsWatchedByUser(first: 3) {\n    edges {\n      node {\n        ...Tag\n        id\n      }\n    }\n  }\n  teamsWatchedByUser(first: 3) {\n    edges {\n      node {\n        id\n        name\n        teamId\n      }\n    }\n  }\n}\n\nfragment GoalUpdateCardFooter on GoalUpdate {\n  id\n  ari\n  updateType\n  missedUpdate\n  goal {\n    ari\n    ...GoalFollowButton\n    id\n  }\n  ...ShareUpdateButton\n}\n\nfragment GoalUpdateCardHeader on GoalUpdate {\n  id\n  goal {\n    ...GoalFollowButton\n    parentGoal {\n      id\n    }\n    key\n    name\n    ...PlatformGoalIcon\n    id\n  }\n}\n\nfragment GoalUpdateCardInternal on GoalUpdate {\n  id\n  ari\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop\n  ...GoalUpdateSummary\n  notes {\n    ...UpdateNote\n    id\n  }\n  ...GoalUpdateDiff\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment GoalUpdateCardProgress on GoalUpdate {\n  metricUpdate {\n    edges {\n      node {\n        newStartValue\n        newTargetValue\n        newValue {\n          value\n          id\n        }\n        metric {\n          id\n          name\n          type\n          subType\n          archived\n        }\n      }\n    }\n  }\n  newProgress {\n    type\n    percentage\n  }\n  goal {\n    id\n    subGoals {\n      count\n    }\n    metricTargets {\n      edges {\n        node {\n          startValue\n          targetValue\n          id\n        }\n      }\n    }\n    ...MetricChart\n  }\n}\n\nfragment GoalUpdateCardTop on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalUpdateCreationDate\n  ...GoalUpdateStatus\n  ...GoalMissedUpdateLabel\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCardTop_PTxnb on GoalUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...GoalMissedUpdateLabel\n  missedUpdate\n  ...GoalUpdateCardProgress\n}\n\nfragment GoalUpdateCard_3UosK1 on GoalUpdate {\n  id\n  uuid\n  creator {\n    aaid\n    id\n  }\n  missedUpdate\n  updateType\n  ...MissedGoalUpdateCard\n  ...GoalUpdateCardInternal\n  goal {\n    uuid\n    ...GoalUpdateCardByline\n    id\n  }\n}\n\nfragment GoalUpdateCreationDate on GoalUpdate {\n  id\n  goal {\n    key\n    id\n  }\n  creator {\n    aaid\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n    }\n    id\n  }\n  creationDate\n  editDate\n}\n\nfragment GoalUpdateDiff on GoalUpdate {\n  ...GoalDateChanged\n  ...GoalStatusChanged\n  ...GoalProgressChanged\n}\n\nfragment GoalUpdateStatus on GoalUpdate {\n  newGoalState: newState {\n    value\n    ...GoalState\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment GoalUpdateSummary on GoalUpdate {\n  summary\n}\n\nfragment LearningCard_cardQuery on Learning {\n  uuid\n  id\n  summary\n  description\n  type\n  ...LearningModifierSignatures_data\n}\n\nfragment LearningModifierSignatures_data on Highlight {\n  __isHighlight: __typename\n  uuid\n  ari\n  project {\n    key\n    ari\n    id\n  }\n  goal {\n    key\n    ari\n    id\n  }\n  creator {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  creationDate\n  lastEditedBy {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  lastEditedDate\n}\n\nfragment LearningsSummary_data on ProjectUpdate {\n  learnings {\n    edges {\n      node {\n        type\n        ...LearningCard_cardQuery\n        id\n      }\n    }\n  }\n}\n\nfragment MetricChart on Goal {\n  ...WrappedWithMetricPopup\n  id\n  progress {\n    type\n    percentage\n  }\n  subGoals {\n    count\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        metric {\n          source\n          latestValue {\n            time\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment MilestoneCard_cardQuery on Milestone {\n  uuid\n  ...MilestoneFields\n}\n\nfragment MilestoneFields on Milestone {\n  id\n  title\n  targetDate\n  targetDateType\n  status\n}\n\nfragment MilestonesSummary_data on ProjectUpdate {\n  milestones {\n    edges {\n      node {\n        ...MilestoneCard_cardQuery\n        id\n      }\n    }\n  }\n}\n\nfragment MissedGoalUpdateCard on GoalUpdate {\n  id\n  ari\n  uuid\n  goal {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...GoalUpdateCardHeader\n  ...GoalUpdateCardTop_PTxnb\n  ...GoalUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment MissedProjectUpdateCard on ProjectUpdate {\n  id\n  ari\n  uuid\n  project {\n    ari\n    uuid\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...ProjectUpdateCardHeader\n  ...ProjectUpdateCardTop_PTxnb\n  ...ProjectUpdateTargetDateAutoUpdated\n  ...LearningsSummary_data\n  ...ProjectUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment ProjectDateChanged on ProjectUpdate {\n  oldDueDate {\n    ...TargetDate\n  }\n  newDueDate {\n    ...TargetDate\n  }\n}\n\nfragment ProjectFollowButton on Project {\n  id\n  uuid\n  watching\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectMissedUpdateLabel on ProjectUpdate {\n  creationDate\n  missedUpdate\n  updateType\n  project {\n    id\n    key\n    latestUserUpdate {\n      id\n      creationDate\n    }\n    latestUpdateDate\n  }\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectStatusChanged on ProjectUpdate {\n  newProjectState: newState {\n    ...ProjectState\n  }\n  oldProjectState: oldState {\n    ...ProjectState\n  }\n}\n\nfragment ProjectUpdateCard on ProjectUpdate {\n  id\n  uuid\n  missedUpdate\n  updateType\n  creator {\n    aaid\n    id\n  }\n  ...MissedProjectUpdateCard\n  ...ProjectUpdateCardInternal\n  project {\n    uuid\n    id\n  }\n  milestones {\n    count\n  }\n  learnings {\n    count\n  }\n  notes {\n    __typename\n    id\n  }\n}\n\nfragment ProjectUpdateCardByline on Project {\n  watching\n  tagsWatchedByUser(first: 3) {\n    edges {\n      node {\n        ...Tag\n        id\n      }\n    }\n  }\n  teamsWatchedByUser(first: 3) {\n    edges {\n      node {\n        id\n        name\n        teamId\n      }\n    }\n  }\n}\n\nfragment ProjectUpdateCardContentExtras on ProjectUpdate {\n  ...ProjectUpdateNotes\n  ...ProjectUpdateDiff\n  ...LearningsSummary_data\n  ...MilestonesSummary_data\n  ...ProjectUpdateTargetDateAutoUpdated\n}\n\nfragment ProjectUpdateCardFooter on ProjectUpdate {\n  ari\n  updateType\n  missedUpdate\n  project {\n    ari\n    ...ProjectFollowButton\n    id\n  }\n  ...ShareUpdateButton\n}\n\nfragment ProjectUpdateCardHeader on ProjectUpdate {\n  project {\n    ...ProjectFollowButton\n    ...ProjectIcon\n    id\n    key\n    name\n  }\n}\n\nfragment ProjectUpdateCardInternal on ProjectUpdate {\n  id\n  ari\n  project {\n    uuid\n    ari\n    workspace {\n      uuid\n      id\n    }\n    id\n  }\n  ...ProjectUpdateCardHeader\n  ...ProjectUpdateCardTop\n  ...ProjectUpdateSummary\n  ...ProjectUpdateCardContentExtras\n  ...ProjectUpdateCardFooter\n  comments {\n    ...Comments\n  }\n}\n\nfragment ProjectUpdateCardTop on ProjectUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...ProjectUpdateCreationDate\n  ...ProjectUpdateStatus\n  ...ProjectMissedUpdateLabel\n}\n\nfragment ProjectUpdateCardTop_PTxnb on ProjectUpdate {\n  ari\n  creator {\n    ...UserAvatar_2aqwkz\n    ...UserName\n    id\n  }\n  ...ProjectMissedUpdateLabel\n  missedUpdate\n}\n\nfragment ProjectUpdateCard_3UosK1 on ProjectUpdate {\n  id\n  uuid\n  missedUpdate\n  updateType\n  creator {\n    aaid\n    id\n  }\n  ...MissedProjectUpdateCard\n  ...ProjectUpdateCardInternal\n  project {\n    uuid\n    ...ProjectUpdateCardByline\n    id\n  }\n  milestones {\n    count\n  }\n  learnings {\n    count\n  }\n  notes {\n    __typename\n    id\n  }\n}\n\nfragment ProjectUpdateCreationDate on ProjectUpdate {\n  id\n  project {\n    key\n    id\n  }\n  creationDate\n  editDate\n  creator {\n    aaid\n    id\n  }\n  lastEditedBy {\n    aaid\n    pii {\n      name\n    }\n    id\n  }\n}\n\nfragment ProjectUpdateDiff on ProjectUpdate {\n  ...ProjectDateChanged\n  ...ProjectStatusChanged\n}\n\nfragment ProjectUpdateNotes on ProjectUpdate {\n  notes {\n    uuid\n    ...UpdateNote\n    id\n  }\n}\n\nfragment ProjectUpdateStatus on ProjectUpdate {\n  newDueDate {\n    ...TargetDate\n  }\n  newProjectState: newState {\n    value\n    ...ProjectState\n  }\n}\n\nfragment ProjectUpdateSummary on ProjectUpdate {\n  summary\n}\n\nfragment ProjectUpdateTargetDateAutoUpdated on ProjectUpdate {\n  project {\n    key\n    id\n  }\n  newTargetDate\n  changelog {\n    newValue\n    oldValue\n    id\n  }\n}\n\nfragment ShareUpdateButton on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n  }\n  ... on GoalUpdate {\n    id\n  }\n  ...ShareUpdateDialogContent\n}\n\nfragment ShareUpdateDialogContent on Update {\n  __isUpdate: __typename\n  ... on ProjectUpdate {\n    id\n    project {\n      key\n      id\n    }\n  }\n  ... on GoalUpdate {\n    id\n    url\n    goal {\n      key\n      id\n    }\n  }\n}\n\nfragment SingleUpdateCard on Update {\n  __isUpdate: __typename\n  __typename\n  ... on ProjectUpdate {\n    ...ProjectUpdateCard_3UosK1\n  }\n  ... on GoalUpdate {\n    ...GoalUpdateCard_3UosK1\n    goal {\n      capabilities {\n        canCommentOnUpdates\n      }\n      id\n    }\n  }\n}\n\nfragment Tag on Tag {\n  ...Tag_createTagOption\n}\n\nfragment Tag_createTagOption on Tag {\n  id\n  name\n  uuid\n  description\n  projectUsageCount\n  goalUsageCount\n  helpPointerUsageCount\n  watcherCount\n}\n\nfragment TargetDate on TargetDate {\n  confidence\n  label\n  localizedLabel {\n    messageId\n  }\n  tooltip: label(longFormat: true)\n  localizedTooltip: localizedLabel(longFormat: true) {\n    messageId\n  }\n  overdue\n}\n\nfragment UpdateNote on UpdateNote {\n  archived\n  uuid\n  title\n  summary\n}\n\nfragment UpdatesFeed on UpdateConnection {\n  edges {\n    node {\n      __typename\n      ... on ProjectUpdate {\n        id\n        ...ProjectUpdateCard\n      }\n      ... on GoalUpdate {\n        id\n        ...GoalUpdateCard\n        goal {\n          capabilities {\n            canCommentOnUpdates\n          }\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n    accountId\n  }\n}\n\nfragment UserName on User {\n  aaid\n  pii {\n    name\n    accountStatus\n  }\n}\n\nfragment WrappedWithMetricPopup on Goal {\n  id\n  progress {\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment common_metricTarget_direct on MetricTarget {\n  startValue\n  targetValue\n  snapshotValue {\n    value\n    id\n  }\n  metric {\n    id\n    name\n    type\n    subType\n  }\n}\n\nfragment hooks_GoalPagination_2vmIz0 on Query {\n  allWatchedGoalUpdatesCount(createdBefore: $createdBefore, createdAfter: $createdAfter, workspaceUUID: $workspaceUUID, stateFilter: $stateFilter)\n  allWatchedGoalUpdates(first: 15, createdBefore: $createdBefore, createdAfter: $createdAfter, workspaceUUID: $workspaceUUID, stateFilter: $stateFilter) {\n    edges {\n      node {\n        __typename\n        ...SingleUpdateCard\n        ... on GoalUpdate {\n          __typename\n          id\n          goal {\n            id\n            name\n          }\n          newGoalState: newState {\n            value\n          }\n          missedUpdate\n          updateType\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment hooks_ProjectPagination_2vmIz0 on Query {\n  allWatchedProjectUpdatesCount(createdBefore: $createdBefore, createdAfter: $createdAfter, workspaceUUID: $workspaceUUID, stateFilter: $stateFilter)\n  allWatchedProjectUpdates(first: 15, createdBefore: $createdBefore, createdAfter: $createdAfter, workspaceUUID: $workspaceUUID, stateFilter: $stateFilter) {\n    edges {\n      node {\n        __typename\n        ...SingleUpdateCard\n        ... on ProjectUpdate {\n          __typename\n          id\n          project {\n            id\n            name\n          }\n          newProjectState: newState {\n            value\n          }\n          missedUpdate\n          updateType\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment hooks_TagPagination_FV1D3 on Query {\n  updatesWithTag(tagUuid: $tagUuid, first: 15, createdAfter: $createdAfter) {\n    edges {\n      __typename\n      node {\n        ...SingleUpdateCard\n        __typename\n        ... on ProjectUpdate {\n          __typename\n          id\n          project {\n            id\n            name\n          }\n          newProjectState: newState {\n            value\n          }\n          missedUpdate\n          updateType\n        }\n        ... on GoalUpdate {\n          __typename\n          id\n          goal {\n            id\n            name\n          }\n          newGoalState: newState {\n            value\n          }\n          missedUpdate\n          updateType\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment hooks_TeamPagination_19TOuK on Query {\n  updatesWithTeam(teamId: $teamId, workspaceUUID: $workspaceUUID, first: 15, createdAfter: $createdAfter) {\n    ...UpdatesFeed\n    edges {\n      __typename\n      node {\n        ...SingleUpdateCard\n        __typename\n        ... on ProjectUpdate {\n          __typename\n          id\n          project {\n            id\n            name\n          }\n          newProjectState: newState {\n            value\n          }\n          missedUpdate\n          updateType\n        }\n        ... on GoalUpdate {\n          __typename\n          id\n          goal {\n            id\n            name\n          }\n          newGoalState: newState {\n            value\n          }\n          missedUpdate\n          updateType\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6599ebc8856d4ab4bf43f087e3b90062";

export default node;
